import axios from './axiosInstance';

export const getDashboard = async () => {
  return axios.get('/analytics/get_dashboard').then(res => res.data);
};

export const getHistory = async () => {
  return axios.get('/service/get_history').then(res => res.data);
};

export const getForecast = async () => {
  return axios.get('/analytics/get_arima_forecast').then(res => res.data);
};

export const getSeasonal = async () => {
  return axios.get('/analytics/get_stl_analytics').then(res => res.data);
};

export const getStock = async () => {
  return axios.get('/service/get_current_stock').then(res => res.data);
};

export const getWarehouses = async () => {
  return axios.get('/service/get_storehouses').then(res => res.data);
};

export const getCategories = async () => {
  return axios.get('/service/get_categories').then(res => res.data);
};

export const getMultiplicity = async () => {
  return axios.get('/analytics/get_multiplicity').then(res => res.data);
};
